module.exports = __webpack_public_path__ + "img/bg-cintillo.71f432fa.71f432fa.jpeg";